import { Link } from "react-router-dom";
import { Anchor, Avatar, Badge, Group, Paper, Stack, Text } from "@mantine/core";
import styles from "./styles/EpisodeListItem.module.css";
import { PlayButton } from "../player/PlayButton";
import { filterTitle, getPodcastImage, ImageSizes, timeAgo } from "@/core/helpers";

interface EpisodeListItemProps {
    episode: Episode;
    podcast: Podcast;
}

export const EpisodeListItem = ({ podcast, episode }: EpisodeListItemProps) => {
    const isVideo = episode.sound.endsWith(".mp4");

    return (
        <Paper className={styles.wrap} p="md" radius="sm" shadow="xs" withBorder>
            <Group align="flex-start" className={styles.item} gap="md" wrap="nowrap">
                <div className={styles.image}>
                    <Avatar
                        imageProps={{ loading: "lazy" }}
                        radius="sm"
                        size={72}
                        src={getPodcastImage(podcast, ImageSizes.Thumb)}>
                        {podcast.name.slice(0, 1)}
                    </Avatar>
                    {!isVideo && (
                        <div className={styles.play}>
                            <PlayButton size={"tiny"} key={episode.guid} podcast={podcast} episode={episode} />
                        </div>
                    )}
                </div>

                <Stack className={styles.info} gap={6}>
                    {isVideo && (
                        <Badge color="cyan" radius="sm" size="sm" variant="filled">
                            Video
                        </Badge>
                    )}

                    <Anchor
                        component={Link}
                        fw={600}
                        lineClamp={2}
                        size="lg"
                        title={episode.title}
                        to={`/podd/${podcast.slug}/${episode.slug}`}
                        underline="hover">
                        <span
                            dangerouslySetInnerHTML={{
                                __html: filterTitle(episode.title),
                            }}
                        />
                    </Anchor>

                    <Anchor component={Link} fw={500} size="sm" to={`/podd/${podcast.slug}`} underline="hover">
                        {podcast.name}
                    </Anchor>

                    <Text c="dimmed" size="sm">
                        <time dateTime={episode.published}>
                            {episode.published.substring(0, 10)} - {timeAgo(episode.published)}
                        </time>
                    </Text>
                </Stack>
            </Group>
        </Paper>
    );
};
